import { render, staticRenderFns } from "./index.vue?vue&type=template&id=50488cc1&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50488cc1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50488cc1')) {
      api.createRecord('50488cc1', component.options)
    } else {
      api.reload('50488cc1', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=50488cc1&scoped=true&", function () {
      api.rerender('50488cc1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistics/quality-control-input/modules/table-list/index.vue"
export default component.exports